import React from "react";
import { UploadCloud, Folder, Trash2, Eye, Plus } from "lucide-react";
import { Field, iCls } from "../_shared";
import { resolveAssetDisplayUrl } from "../../../lib/assetUrl";
import { emptyAsset } from "./adminSettingsDefaults";
import { useAdminSettings } from "./AdminSettingsContext";

export default function AdminSettingsAbout() {
  const ctx = useAdminSettings();
  return (
    <>
            <div className="rounded-2xl border border-admin-border bg-admin-surface p-6 shadow-sm">
              <h3 className="text-lg font-extrabold text-admin-text mb-2">Ảnh nền trang Giới thiệu</h3>
              <p className="mb-5 text-sm text-admin-textMuted">Ảnh nền hero cho trang Giới thiệu (preview nội bộ).</p>

              {(() => {
                const asset = ctx.data?.aboutPage?.hero?.background || {};
                const src = resolveAssetDisplayUrl(asset?.url, asset?.key);
                const label = "Trang About us";
                const path = "aboutPage.hero.background";
                return (
                  <div className="rounded-xl border border-admin-border bg-admin-surface p-4">
                    <div className="flex items-start justify-between gap-3">
                      <div>
                        <p className="font-semibold text-admin-text">{label}</p>
                        <p className="mt-0.5 text-xs text-admin-textMuted">Ảnh nền cho hero trang Giới thiệu</p>
                      </div>
                      <div className="flex items-center gap-2">
                        <label className="inline-flex cursor-pointer items-center gap-2 rounded-2xl border border-admin-border bg-admin-surface px-3.5 py-2 text-xs font-extrabold text-admin-text shadow-sm transition hover:bg-admin-muted">
                          <UploadCloud className="h-4 w-4" />
                          Tải từ máy
                          <input
                            type="file"
                            className="sr-only"
                            accept="image/*"
                            onChange={(e) => {
                              const file = e.target.files?.[0];
                              if (file) ctx.uploadLocalImageToMedia({ path, file, prefix: "site/" });
                              e.target.value = "";
                            }}
                          />
                        </label>
                        <button
                          type="button"
                          onClick={() =>
                            ctx.setShowMediaPicker({
                              path,
                              title: `Chọn ảnh nền — ${label}`,
                              initialPrefix: "site/",
                              accept: "image",
                            })
                          }
                          className="inline-flex items-center gap-2 rounded-xl bg-admin-primary px-3.5 py-2 text-xs font-extrabold text-white shadow-sm transition hover:bg-admin-primaryHover active:scale-[0.98]"
                          style={{ boxShadow: "0 1px 0 rgba(0,0,0,0.18) inset, 0 3px 8px rgba(37,106,191,0.25)" }}
                        >
                          <Folder className="h-4 w-4" />
                          Chọn từ Media
                        </button>
                        <button
                          type="button"
                          onClick={() => ctx.updateField(path, { ...emptyAsset })}
                          className="inline-flex items-center gap-2 rounded-2xl border border-admin-border bg-admin-surface px-3.5 py-2 text-xs font-extrabold text-admin-text shadow-sm transition hover:bg-admin-muted active:scale-[0.98]"
                          title="Xóa ảnh nền"
                        >
                          <Trash2 className="h-4 w-4" />
                          Xóa
                        </button>
                      </div>
                    </div>

                    <div className="mt-4">
                      {src ? (
                        <div className="overflow-hidden rounded-lg border border-admin-border bg-admin-muted">
                          <img src={src} alt={label} className="h-40 w-full object-cover bg-white" referrerPolicy="no-referrer" />
                        </div>
                      ) : (
                        <div className="flex h-40 items-center justify-center rounded-lg border border-dashed border-admin-border bg-admin-muted text-sm text-admin-textMuted">
                          Chưa có ảnh nền
                        </div>
                      )}

                      {(asset?.key || asset?.url) ? (
                        <div className="mt-2 text-xs text-admin-textMuted break-all">
                          <span className="font-medium">key:</span> {asset.key || "—"}<br />
                          <span className="font-medium">url:</span> {asset.url || "—"}
                        </div>
                      ) : null}
                    </div>
                  </div>
                );
              })()}
            </div>
            <div className="rounded-2xl border border-admin-border bg-admin-surface p-6 shadow-sm">
              <div className="mb-4 flex items-center justify-between gap-3">
                <h3 className="text-lg font-extrabold text-admin-text">SEO Giới thiệu</h3>
                <button
                  type="button"
                  onClick={() => ctx.setShowPagePreview({ title: "Giới thiệu", routePath: "/__preview/about#about-hero", page: "about", scrollToId: "about-hero" })}
                  className="inline-flex items-center gap-2 rounded-full border border-admin-border bg-admin-surface px-4 py-2 text-sm font-semibold text-admin-text transition hover:bg-admin-muted"
                >
                  <Eye className="w-4 h-4" />
                  Preview giới thiệu
                </button>
              </div>
              <div className="space-y-4">
                <Field label="Tiêu đề SEO">
                  <input
                    type="text"
                    className={iCls}
                    value={ctx.data.aboutPage?.seo?.title || ""}
                    onChange={(e) => ctx.updateField("aboutPage.seo.title", e.target.value)}
                  />
                </Field>
                <Field label="Mô tả SEO">
                  <textarea
                    className={iCls}
                    rows={3}
                    value={ctx.data.aboutPage?.seo?.description || ""}
                    onChange={(e) => ctx.updateField("aboutPage.seo.description", e.target.value)}
                  />
                </Field>
                <Field label="Từ khóa SEO (phân tách bằng dấu phẩy)">
                  <input
                    type="text"
                    className={iCls}
                    value={(ctx.data.aboutPage?.seo?.keywords || []).join(", ")}
                    onChange={(e) =>
                      ctx.updateField(
                        "aboutPage.seo.keywords",
                        e.target.value.split(",").map((k) => k.trim()).filter(Boolean)
                      )
                    }
                  />
                </Field>
                <Field label="URL canonical">
                  <input
                    type="url"
                    className={iCls}
                    value={ctx.data.aboutPage?.seo?.url || ""}
                    onChange={(e) => ctx.updateField("aboutPage.seo.url", e.target.value)}
                  />
                </Field>
                <div className="rounded-xl border border-admin-border bg-admin-muted p-4">
                  <p className="text-xs font-bold uppercase tracking-wider text-admin-textMuted mb-3">Organization (SEO)</p>
                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                    <Field label="Tên tổ chức">
                      <input
                        type="text"
                        className={iCls}
                        value={ctx.data.aboutPage?.seo?.organization?.name || ""}
                        onChange={(e) => ctx.updateField("aboutPage.seo.organization.name", e.target.value)}
                      />
                    </Field>
                    <Field label="URL tổ chức">
                      <input
                        type="url"
                        className={iCls}
                        value={ctx.data.aboutPage?.seo?.organization?.url || ""}
                        onChange={(e) => ctx.updateField("aboutPage.seo.organization.url", e.target.value)}
                      />
                    </Field>
                    <Field label="Logo URL">
                      <input
                        type="url"
                        className={iCls}
                        value={ctx.data.aboutPage?.seo?.organization?.logo || ""}
                        onChange={(e) => ctx.updateField("aboutPage.seo.organization.logo", e.target.value)}
                      />
                    </Field>
                    <Field label="SameAs (phân tách bằng dấu phẩy)">
                      <input
                        type="text"
                        className={iCls}
                        value={(ctx.data.aboutPage?.seo?.organization?.sameAs || []).join(", ")}
                        onChange={(e) =>
                          ctx.updateField(
                            "aboutPage.seo.organization.sameAs",
                            e.target.value.split(",").map((x) => x.trim()).filter(Boolean)
                          )
                        }
                      />
                    </Field>
                  </div>
                </div>
              </div>
            </div>

            <div className="rounded-2xl border border-admin-border bg-admin-surface p-6 shadow-sm">
              <h3 className="text-lg font-extrabold text-admin-text mb-4">Hero Giới thiệu</h3>
              <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
                <Field label="Kicker">
                  <input
                    type="text"
                    className={iCls}
                    value={ctx.data.aboutPage?.hero?.kicker || ""}
                    onChange={(e) => ctx.updateField("aboutPage.hero.kicker", e.target.value)}
                  />
                </Field>
                <Field label="Tiêu đề">
                  <input
                    type="text"
                    className={iCls}
                    value={ctx.data.aboutPage?.hero?.title || ""}
                    onChange={(e) => ctx.updateField("aboutPage.hero.title", e.target.value)}
                  />
                </Field>
                <Field label="Phụ đề" className="sm:col-span-2">
                  <textarea
                    className={iCls}
                    rows={3}
                    value={ctx.data.aboutPage?.hero?.subtitle || ""}
                    onChange={(e) => ctx.updateField("aboutPage.hero.subtitle", e.target.value)}
                  />
                </Field>
                <Field label="Nút chính - Label">
                  <input
                    type="text"
                    className={iCls}
                    value={ctx.data.aboutPage?.hero?.primaryButtonLabel || ""}
                    onChange={(e) => ctx.updateField("aboutPage.hero.primaryButtonLabel", e.target.value)}
                  />
                </Field>
                <Field label="Nút chính - Link">
                  <input
                    type="text"
                    className={iCls}
                    value={ctx.data.aboutPage?.hero?.primaryButtonTo || ""}
                    onChange={(e) => ctx.updateField("aboutPage.hero.primaryButtonTo", e.target.value)}
                  />
                </Field>
                <Field label="Nút phụ - Label">
                  <input
                    type="text"
                    className={iCls}
                    value={ctx.data.aboutPage?.hero?.secondaryButtonLabel || ""}
                    onChange={(e) => ctx.updateField("aboutPage.hero.secondaryButtonLabel", e.target.value)}
                  />
                </Field>
                <Field label="Nút phụ - Link">
                  <input
                    type="text"
                    className={iCls}
                    value={ctx.data.aboutPage?.hero?.secondaryButtonTo || ""}
                    onChange={(e) => ctx.updateField("aboutPage.hero.secondaryButtonTo", e.target.value)}
                  />
                </Field>
              </div>
            </div>

            <div className="overflow-hidden rounded-2xl border border-admin-border bg-admin-surface shadow-sm ring-1 ring-black/[0.03]">
              <div className="border-b border-admin-border bg-admin-muted/40 px-6 py-4">
                <div className="flex items-center justify-between gap-3">
                <h3 className="text-sm font-extrabold uppercase tracking-wider text-admin-text">Stats</h3>
                <button
                  type="button"
                  onClick={() => ctx.addArrayItem("aboutPage.stats", { value: "", label: "" })}
                  className="inline-flex items-center gap-1.5 rounded-xl bg-admin-primary px-3 py-1.5 text-xs font-bold text-white shadow-sm transition hover:bg-admin-primaryHover"
                  style={{ boxShadow: "0 1px 0 rgba(0,0,0,0.14) inset, 0 2px 6px rgba(37,106,191,0.22)" }}
                >
                  <Plus className="w-3.5 h-3.5" />
                  Thêm
                </button>
                </div>
              </div>
              <div className="space-y-3 p-6">
                {(ctx.data.aboutPage?.stats || []).map((it, idx) => (
                  <div key={idx} className="grid grid-cols-1 sm:grid-cols-[1fr,2fr,auto] gap-3 items-start">
                    <input className={iCls} value={it.value || ""} onChange={(e) => ctx.updateArrayItem("aboutPage.stats", idx, "value", e.target.value)} placeholder="50+" />
                    <input className={iCls} value={it.label || ""} onChange={(e) => ctx.updateArrayItem("aboutPage.stats", idx, "label", e.target.value)} placeholder="Địa điểm" />
                    <button type="button" onClick={() => ctx.removeArrayItem("aboutPage.stats", idx)}
                      className="inline-flex items-center justify-center rounded-xl border border-rose-200 bg-rose-50 text-rose-600 px-3 py-2 transition hover:bg-rose-100" aria-label="Xóa">
                      <Trash2 className="w-4 h-4" />
                    </button>
                  </div>
                ))}
              </div>
            </div>

            <div className="overflow-hidden rounded-2xl border border-admin-border bg-admin-surface shadow-sm ring-1 ring-black/[0.03]">
              <div className="border-b border-admin-border bg-admin-muted/40 px-6 py-4">
                <h3 className="text-sm font-extrabold uppercase tracking-wider text-admin-text">Story section</h3>
              </div>
              <div className="space-y-4 p-6">
              <div className="space-y-4">
                <Field label="Kicker">
                  <input
                    type="text"
                    className={iCls}
                    value={ctx.data.aboutPage?.storySection?.kicker || ""}
                    onChange={(e) => ctx.updateField("aboutPage.storySection.kicker", e.target.value)}
                  />
                </Field>
                <Field label="Title">
                  <input
                    type="text"
                    className={iCls}
                    value={ctx.data.aboutPage?.storySection?.title || ""}
                    onChange={(e) => ctx.updateField("aboutPage.storySection.title", e.target.value)}
                  />
                </Field>
                <Field label="Story">
                  <textarea
                    className={iCls}
                    rows={6}
                    value={ctx.data.aboutPage?.storySection?.story || ""}
                    onChange={(e) => ctx.updateField("aboutPage.storySection.story", e.target.value)}
                  />
                </Field>
                <Field label="Location badge title">
                  <input
                    type="text"
                    className={iCls}
                    value={ctx.data.aboutPage?.storySection?.locationBadgeTitle || ""}
                    onChange={(e) => ctx.updateField("aboutPage.storySection.locationBadgeTitle", e.target.value)}
                  />
                </Field>
                <Field label="Location badge desc">
                  <input
                    type="text"
                    className={iCls}
                    value={ctx.data.aboutPage?.storySection?.locationBadgeDesc || ""}
                    onChange={(e) => ctx.updateField("aboutPage.storySection.locationBadgeDesc", e.target.value)}
                  />
                </Field>
                <Field label="Checklist (phân tách bằng dấu xuống dòng)">
                  <textarea
                    className={iCls}
                    rows={4}
                    value={(ctx.data.aboutPage?.storySection?.checklist || []).join("\n")}
                    onChange={(e) =>
                      ctx.updateField(
                        "aboutPage.storySection.checklist",
                        e.target.value.split("\n").map((s) => s.trim()).filter(Boolean)
                      )
                    }
                  />
                </Field>
              </div>
              </div>
            </div>
    </>
  );
}
